import { first_truthy, normalize_text, to_number } from './view_case_details_core_helpers';

function to_array(value) {
  return Array.isArray(value) ? value : [];
}

export function response_data_array(response) {
  return to_array(response_data_value(response));
}

export function response_data_value(response) {
  return response?.data?.data ?? response?.data ?? response;
}

export function response_log_id(payload = {}) {
  const candidates = response_log_candidates(payload);
  const log_id = candidates
    .map((candidate) => to_number(candidate?.id || candidate?.approval_log_id || candidate?.log_id))
    .find(Boolean);

  return log_id || null;
}

function response_log_candidates(payload) {
  const data = response_data_value(payload);
  return [data, data?.data];
}

export function application_form_id(application_form = {}) {
  return to_number(first_truthy([
    application_form?.form?.id,
    application_form?.form_id,
    application_form?.id,
  ]));
}

export function application_form_record_id(application_form = {}) {
  return to_number(first_truthy([
    application_form?.application_form_id,
    application_form?.applicationFormId,
    application_form?.id,
  ]));
}

export function normalize_assigned_form_status(status = {}, index = 0) {
  return {
    id: to_number(first_truthy([status?.id, status?.assigned_form_status_id])),
    form_id: to_number(first_truthy([status?.form_id, status?.form?.id])),
    status_id: to_number(first_truthy([status?.status_id, status?.workflow_status_id])),
    name: assigned_form_status_name(status, index),
    order: Number(first_truthy([status?.order, status?.sequence, status?.sort_order, index + 1])),
    is_initial: Boolean(status?.is_initial),
    is_final: Boolean(status?.is_final),
  };
}

function assigned_form_status_name(status, index) {
  return normalize_text(first_truthy([
    status?.status_name,
    status?.workflow_status_name,
    status?.status,
    status?.name,
    `Status ${index + 1}`,
  ]));
}

export function unique_statuses(statuses = []) {
  const seen = new Set();
  return statuses.filter((status) => unique_status(status, seen));
}

function unique_status(status, seen) {
  const key = String(status.id || status.name || '').toLowerCase();
  if (!key || seen.has(key)) return false;

  seen.add(key);
  return true;
}

export function workflow_status_label(status = {}) {
  return normalize_text(first_truthy([status?.name, status?.status_name, status?.status, status]));
}

export function response_status_label(response = {}) {
  const status_label = normalize_text(first_truthy([
    response?.data?.data?.status,
    response?.data?.data?.application_status,
    response?.data?.status,
    response?.data?.status_name,
    response?.data?.application_status,
    response?.status_name,
    response?.application_status,
    response?.status,
  ]));

  return ['success', 'error'].includes(status_label.toLowerCase()) ? '' : status_label;
}

export function normalize_transition_rule(rule = {}) {
  return {
    id: to_number(first_truthy([rule?.id, rule?.rule_id])),
    from_status_id: to_number(first_truthy([rule?.from_status_id, rule?.from_status?.id, rule?.sourceId])),
    to_status_id: to_number(first_truthy([rule?.to_status_id, rule?.to_status?.id, rule?.targetId])),
    to_status_name: normalize_text(first_truthy([rule?.to_status, rule?.to_status?.status_name, rule?.target])),
    is_active: rule?.is_active !== false,
  };
}
